import 'construct-style-sheets-polyfill'; const styleSheet = new CSSStyleSheet(); styleSheet.replaceSync(`.fab-container {
    position: fixed;
    bottom: 2.5em;
    right: 2.5em;
}

.icon-button {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.5em;
    height: 2.5em;
    border-radius: 100%;
    box-shadow: 0.5em 0.5em 0.25em rgba(170, 170, 170, 0.5);
}

button {
    font-size: inherit;
    border: none;
    background: var(
        --inv-button-fab-background,
        linear-gradient(93.64deg, #00d5e0 1%, #15a6da 26.85%, #004bba 86.58%, #0f4595 99.6%)
    );
}

.icon-container {
    height: 2.2em;
    width: 2.2em;
}

.icon-container.show {
    transform: rotate(45deg);
}

.fab-menu {
    display: none;
}

.show {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

button:hover {
    background: var(--inv-button-fab-hover-background, #0e4dab);
}

.button-container {
    display: flex;
    justify-content: flex-end;
}
`); export default styleSheet;